export const testimonyQuoteIconTokens = [
    'quote',
    'messageQuote',
    'messageCircle',
    'sparkles',
    'star',
    'award',
    'shieldCheck',
] as const;

export type TestimonyQuoteIconToken = (typeof testimonyQuoteIconTokens)[number];

export const testimonyQuoteTokens = {
    colors: {
        background: '#f8fafc',
        surface: '#ffffff',
        text: '#071735',
        textSoft: '#25334d',
        textMuted: '#536278',
        accent: '#0f8a5f',
        accentContrast: '#ffffff',
        accentSoft: 'color-mix(in srgb, var(--testimony-quote-accent) 12%, transparent)',
        border: 'rgba(7, 23, 53, 0.1)',
        imageFallback: '#e6edf3',
        shadow: '0 24px 70px rgba(7, 23, 53, 0.12)',
    },
    icons: {
        quote: 'quote' as TestimonyQuoteIconToken,
    },
    radius: {
        card: 8,
        image: 8,
        icon: 999,
    },
    sizes: {
        maxWidth: 1180,
        icon: 58,
        imageMinHeight: 420,
        mobileImageMinHeight: 260,
        imageAspectRatio: '4 / 5',
    },
    spacing: {
        sectionY: 56,
        sectionX: 24,
        cardPadding: 42,
        cardGap: 44,
        tabletCardPadding: 32,
        tabletCardGap: 30,
        mobileSectionY: 36,
        mobileSectionX: 16,
        mobileCardPadding: 22,
    },
    typography: {
        fontFamily:
            'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        eyebrow: {
            fontSize: 13,
            lineHeight: 1.1,
            fontWeight: 850,
            letterSpacing: 0,
            textTransform: 'uppercase' as const,
        },
        quote: {
            fontSize: 34,
            tabletFontSize: 29,
            mobileFontSize: 23,
            lineHeight: 1.26,
            mobileLineHeight: 1.34,
            fontWeight: 760,
            letterSpacing: 0,
        },
        author: {
            fontSize: 17,
            mobileFontSize: 16,
            lineHeight: 1.16,
            fontWeight: 850,
            letterSpacing: 0,
        },
        meta: {
            fontSize: 14,
            mobileFontSize: 13,
            lineHeight: 1.35,
            fontWeight: 550,
            letterSpacing: 0,
        },
    },
    image: {
        objectPosition: 'center',
    },
} as const;

export type TestimonyQuoteColorToken = keyof typeof testimonyQuoteTokens.colors;
export type TestimonyQuoteIconSlot = keyof typeof testimonyQuoteTokens.icons;
